import { Component } from '@theme/component';

class TabContent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  #init() {
    // Shopify's Blocks API wraps each block in a <div>. Find direct children
    // (the wrappers) that contain a [data-tab-title] descendant.
    /** @type {{ wrapper: HTMLElement, title: string, url: string }[]} */
    const wrapperPanels = [];
    for (const wrapper of this.children) {
      const panel = wrapper.matches('[data-tab-title]')
        ? wrapper
        : wrapper.querySelector('[data-tab-title]');
      if (panel instanceof HTMLElement && panel.dataset.tabTitle) {
        wrapperPanels.push({
          wrapper: /** @type {HTMLElement} */ (wrapper),
          title: panel.dataset.tabTitle,
          url: panel.dataset.collectionUrl ?? '',
        });
      }
    }

    /** @type {HTMLAnchorElement | null} */
    const generalButton = this.querySelector('[data-tab-general-button] a');
    const urls = wrapperPanels.map((d) => d.url);

    if (generalButton && wrapperPanels[0]) this.#updateGeneralButton(generalButton, wrapperPanels[0].url);

    if (wrapperPanels.length < 2) return;

    const nav = document.createElement('div');
    nav.className = 'cc-tab-nav';
    nav.setAttribute('role', 'tablist');

    const wrappers = wrapperPanels.map((d) => d.wrapper);

    wrapperPanels.forEach(({ wrapper, title }, i) => {
      wrapper.setAttribute('role', 'tabpanel');
      if (i !== 0) wrapper.classList.add('hidden');

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-tab-btn';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.textContent = title;
      btn.addEventListener('click', () => this.#activate(wrappers, i, urls, generalButton));
      nav.append(btn);
    });

    this.prepend(nav);
  }

  /**
   * @param {Element[]} panels
   * @param {number} activeIndex
   * @param {string[]} urls
   * @param {HTMLAnchorElement | null} generalButton
   */
  #activate(panels, activeIndex, urls, generalButton) {
    const btns = [...this.querySelectorAll('.cc-tab-btn')];
    panels.forEach((panel, i) => {
      const isActive = i === activeIndex;
      btns[i]?.setAttribute('aria-selected', isActive ? 'true' : 'false');
      panel.classList.toggle('hidden', !isActive);
    });
    if (generalButton) this.#updateGeneralButton(generalButton, urls[activeIndex]);
  }

  /**
   * @param {HTMLAnchorElement} anchor
   * @param {string} [url]
   */
  #updateGeneralButton(anchor, url) {
    if (!url) {
      anchor.removeAttribute('href');
      anchor.setAttribute('role', 'link');
      anchor.setAttribute('aria-disabled', 'true');
      return;
    }
    anchor.href = url;
    anchor.removeAttribute('role');
    anchor.removeAttribute('aria-disabled');
  }
}

if (!customElements.get('tab-content')) {
  customElements.define('tab-content', TabContent);
}
